import { Medal, Flame, Trophy, Lock } from "lucide-react";

export const BADGES = [
  { threshold: 10, label: "Régulier", Icon: Medal, blurb: "10 séances réalisées" },
  { threshold: 25, label: "Engagé", Icon: Flame, blurb: "25 séances réalisées" },
  { threshold: 50, label: "Champion", Icon: Trophy, blurb: "50 séances réalisées" },
];

export function highestBadge(count) {
  const earned = BADGES.filter((b) => count >= b.threshold);
  return earned.length ? earned[earned.length - 1] : null;
}

export default function Badges({ count = 0 }) {
  return (
    <div data-testid="badges-grid" className="grid gap-4 sm:grid-cols-3">
      {BADGES.map((b) => {
        const earned = count >= b.threshold;
        const progress = Math.min(100, Math.round((count / b.threshold) * 100));
        const Icon = b.Icon;
        return (
          <div
            key={b.threshold}
            data-testid={`badge-${b.threshold}`}
            className={`hover-lift relative overflow-hidden rounded-2xl border p-6 transition-colors ${
              earned ? "border-[#3b82f6] bg-white" : "border-stone-200 bg-white"
            }`}
          >
            <div className="flex items-start justify-between">
              <div
                className={`flex h-14 w-14 items-center justify-center rounded-full transition-colors ${
                  earned ? "bg-[#3b82f6] text-white" : "bg-stone-100 text-stone-400"
                }`}
              >
                {earned ? (
                  <Icon className="h-6 w-6" strokeWidth={1.75} />
                ) : (
                  <Lock className="h-5 w-5" strokeWidth={1.75} />
                )}
              </div>
              <span
                className={`rounded-full px-3 py-1 text-[10px] font-medium uppercase tracking-[0.24em] ${
                  earned ? "bg-[#8B7D6B]/10 text-[#8B7D6B]" : "bg-stone-100 text-stone-500"
                }`}
              >
                {earned ? "Débloqué" : "À venir"}
              </span>
            </div>
            <p className="font-display mt-6 text-2xl font-light text-stone-900">{b.label}</p>
            <p className="mt-1 text-sm text-stone-500">{b.blurb}</p>
            {!earned && (
              <div className="mt-5">
                <div className="mb-2 flex items-center justify-between text-xs text-stone-500">
                  <span data-testid={`badge-progress-${b.threshold}`}>{count}/{b.threshold}</span>
                  <span>{progress}%</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-stone-100">
                  <div className="h-full bg-[#8B7D6B] transition-all" style={{ width: `${progress}%` }} />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
